const DOMAIN = 'lending.services.public.onboarding.lzOnboarding.uploadIdContainer.landing.';

const DESCRIPTION = `${DOMAIN}link`,
  UPLOAD_AGAIN = `${DOMAIN}uploadAgainLink`;

export { DESCRIPTION, UPLOAD_AGAIN };
